import script from "./Intro1_4_1.vue?vue&type=script&setup=true&lang=js"
export * from "./Intro1_4_1.vue?vue&type=script&setup=true&lang=js"

import "./Intro1_4_1.vue?vue&type=style&index=0&id=752a763b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\local\\Desktop\\repo\\zesl-osa-tu\\frontend-osa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-752a763b"]])

export default __exports__